import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TravelRoute } from '../models/travel-route';
import { Customer } from '../models/customer';

@Injectable({
  providedIn: 'root'
})
export class TravelRouteService {

  constructor(private http:HttpClient) { }

  getRoute(id:number) : Promise<TravelRoute> {
    return this.http.get<TravelRoute>('/api/route/' + id).toPromise();
  }

  putTravelRoute(route:TravelRoute) : Promise<TravelRoute> {
    return this.http.post<TravelRoute>('/api/route/' + route.id + '/edit', route)
      .toPromise();
  }

  getByCustomer(customer:Customer) : Promise<TravelRoute[]> {
    return this.http.get<TravelRoute[]>('/api/route?customer_id=' + customer.id)
      .toPromise();
  }

  getByAddresses(source_address:number, target_address_2:number) : Promise<TravelRoute[]> {
    return this.http.get<TravelRoute[]>('/api/route?source_address=' + source_address + '&target_address=' + target_address_2)
      .toPromise();
  }

  postTravelRoute(route:TravelRoute) : Promise<TravelRoute> {
    return this.http.post<TravelRoute>('/api/route', route)
      .toPromise();
  }

  getByCustomerSimple(customer:Customer) : Promise<TravelRoute[]> {
    return this.http.get<TravelRoute[]>('/api/route/simple?customer_id=' + customer.id)
      .toPromise();
  }

   getExpensesByRoute(id:number) : Promise<any[]> {
    return this.http.get<any[]>('/api/route/expenses?id=' + id)
      .toPromise();
  }
  
  getRouteExcel(params) {
    return this.http.post('/api/excel/route',params,
      {responseType: 'blob'}).toPromise();
  }
}
